// Module
var code = `<div id="alerts" class="hidden-print" ng-show="messageController.messages.length > 0"> <div ng-repeat="message in messageController.messages" data-ng-click="message.remove()" class="animate alert alert-{{ message.type }}"> <span ng-bind-html="message.text"></span> </div> </div> `;
// Exports
module.exports = code;